/**
 * Component that show message when form is saved
 *
 * @param onBackHome
 * @param progresStep
 * @returns {JSX.Element}
 * @constructor
 */
const MessageSaveForm = ({onBackHome, progresStep}) => {
	var message = `
    <p> <strong> Votre sauvegarde a bien été prise en compte. </strong> </p>

    <p>Un email vous a été envoyé comprenant un lien vous permettant de poursuivre votre saisie.</p> `;


	return <>
		<div style={{marginBottom: '15px'}} className="steps_v2 fullwidth tunnel_v2 ">
			<ol className="list-steps el-">
				<li data-idx="7" className={`item-5 current   fill-${progresStep.pourcentage} `}>
					<div className="rounded">
						<div className="circle white">
							<span className="">{progresStep.number}</span>
						</div>
						<div className="circle grey">
							<div className="segment">
							</div>
						</div>
					</div>
				</li>
			</ol>
		</div>

		<div style={{textAlign: 'center'}} dangerouslySetInnerHTML={{__html: message}} className="card-body"></div>


		<div className="bottom">
			<div className="prev_next stepper">
				<div id="prev_mobile">
					<button onClick={onBackHome} style={{marginRight: '0px'}}
							className="bouton-picto-left goto_backto ">Revenir sur la page d’accueil
					</button>

				</div>
			</div>
		</div>


	</>
}

export default MessageSaveForm;
